// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1D914","rootSmall":"AddTileButton_rootSmall__1Nb7v"};